import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createBrtaCode,
  deleteBrtaCode,
  editBrtaCode,
  getBrtaCodes,
} from "api/brtaCodeApi";

export const BRTA_CODES_QUERY_KEY = "brta-codes";

export const useBrtaCodes = (params = { all: true }) => {
  return useQuery({
    queryKey: [BRTA_CODES_QUERY_KEY, params],
    queryFn: () => getBrtaCodes(params),
    keepPreviousData: true,
  });
};

export const useCreateBrtaCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createBrtaCode,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRTA_CODES_QUERY_KEY]);
      }
    },
  });
};

export const useEditBrtaCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: editBrtaCode,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRTA_CODES_QUERY_KEY]);
      }
    },
  });
};

export const useDeleteBrtaCode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteBrtaCode,
    onSuccess: data => {
      if (data?.success) {
        queryClient.invalidateQueries([BRTA_CODES_QUERY_KEY]);
      }
    },
  });
};
